import { caseNameUpdateAction } from '../actions/form';
import { createReducer } from 'redux-create-reducer';

const dirtyReducer = createReducer(false, {
  [caseNameUpdateAction]: (state, action) => true,
});

export default dirtyReducer;

export const getIsDirty = state => state.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/reducers/dirty.js